import React from 'react';

import Box from '@amzn/meridian/box';
import Input from '@amzn/meridian/input';
import Text from '@amzn/meridian/text';

interface FrequencySelectorProps {
  selectedValue?: number;
  onChange: (value: number) => void;
  errorMessage?: string;
  isDisabled: boolean;
  /** @testOnly */
  index: number;
}
const FrequencySelector = ({ selectedValue, isDisabled, errorMessage, onChange, index }: FrequencySelectorProps) => {
  return (
    <Box>
      <Text data-testid="new-jmr__npl__field-label">Frequency per Shift</Text>
      <Input
        aria-label="Frequency per Shift"
        type="number"
        data-cy={`new-jmr__limitations__frequency-selector__${index}`}
        placeholder="Enter frequency"
        value={selectedValue}
        onChange={(val) => {
          if (+val >= 0) {
            return onChange(val);
          }
        }}
        errorMessage={errorMessage}
        error={!!errorMessage}
        disabled={isDisabled}
      />
    </Box>
  );
};

// **** Export **** //

export default FrequencySelector;
